// =============================
// Imports
// =============================

// External dependencies
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';

// Config
import { withTranslation } from '../config/i18n';

// Components
import PrivateRoute from '../components/containers/privateRoute';
import Cookies from '../components/layouts/cookies';

// Helpers
import { getWebsiteTitle } from '../helpers/misc';
import * as pth from '../helpers/proptypes';

// =============================
// Page
// =============================

class CookiesPage extends PureComponent {
  static propTypes = {
    config: pth.config.isRequired,
    t: PropTypes.func.isRequired,
  };

  static async getInitialProps() {
    return {
      namespacesRequired: ['pages'],
    };
  }

  render() {
    const { config, t } = this.props;

    return (
      <PrivateRoute>
        <NextSeo title={getWebsiteTitle(config, t('pages:cookies.meta_title'))} noindex />
        <Cookies t={t} />
      </PrivateRoute>
    );
  }
}

export default withTranslation('pages')(CookiesPage);
